const AllDevices = () => import("./views/AllDevices.vue");
const DeviceForm = () => import("./views/DeviceForm.vue");
const EditDeviceForm = () => import("./views/EditDeviceForm.vue");
const UserTransfer = () => import("./views/UserTransfer.vue");
const DeviceTransactions = () => import("./views/DeviceTransactions.vue");
const Reboot = () => import("./views/Reboot.vue");
export default [
  {
    path: "all",
    component: AllDevices,
    name: "viewAllDevices",
  },
  {
    path: "create",
    component: DeviceForm,
  },
  {
    path: "edit/:id",
    name: "edit-device",
    component: EditDeviceForm,
  },
  {
    path: "user-transfer",
    component: UserTransfer,
  },
  {
    path: "transactions",
    component: DeviceTransactions,
  },
  {
    path: "transactions/logs/:id",
    component: Reboot,
    name: "view-transaction-logs",
  },
];
